module.exports = __webpack_public_path__ + "media/images/mailer/award-3d1477d40214db7b548c98de24740f22.png";